export default {
  getData (state) {
    return state.database
  },
  getWater (state) {
    return state.PersonalBill.Water
  },
  getCard (state) {
    return state.PersonalBill.Card
  },
  getCash (state) {
    return state.PersonalBill.Cash
  },
  getPersonalBil (state) {
    return state.PersonalBill
  },
  getTitle (state) {
    return state.title
  }
}



// WEBPACK FOOTER //
// ./src/store/data/getters.js